<template>
	<div id="subscription" class="subscription">
		<vue-snotify></vue-snotify>
		<div v-if="data">
			<div class="alert alert-warning" role="alert"
				v-if="data.genesys == null && needGenesys && data.status_id == 31">
				Esta Suscripción no está migrada a Genesys
			</div>
			<div class="row">
				<div class="col-8">
					<div class="card border-secondary mb-3">
						<div class="card-header">
							Detalle de productos ({{ data.order_products.length }})
							<span @click="opendetail = !opendetail" class="pointer float-right text-secondary">
								<i class="fas fa-plus" v-if="!opendetail"></i>
								<i class="fas fa-minus" v-else></i>
							</span>
						</div>
						<div class="card-body" v-show="opendetail">
							<table class="table table-sm table-hover table-striped table-12">
								<thead>
									<tr>
										<th class="text-center">Codigo</th>
										<th class="text-center">Producto</th>
										<th class="text-center">Cantidad</th>
										<th class="text-center">Precio</th>
										<th class="text-center">Total</th>
										<th class="text-center">
											Envios
										</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in data.order_products" :key="index">
										<td class="text-center">{{ item.product_id }}</td>
										<td>{{ item.product }}</td>
										<td class="text-right" :title="'Original = ' + item.quantity"
											:class="(item.quantity == analizeQuantitySubscriptionProducts(item.order_product_subscription_products)) ? 'text-dark' : 'text-warning'">
											{{
			methodFormatNumber(analizeQuantitySubscriptionProducts(item.order_product_subscription_products))
		}}
										</td>
										<td class="text-right">{{ methodFormatNumber(item.price) }}</td>
										<td class="text-right">{{ methodFormatNumber(item.price * item.quantity) }}</td>
										<td class="text-right">
											<span
												v-for="(ite, inde) in analizeSubscriptionProducts(item.order_product_subscription_products)"
												:key="inde">
												<i class="fas fa-minus" v-if="ite.status_id == null"
													:title="methodFormatNumber(analizeQuantitySubscriptionProducts(item.order_product_subscription_products)) + ' ' + ite.product.name + ' por envíar'"
													:class="(methodFormatNumber(analizeQuantitySubscriptionProducts(item.order_product_subscription_products)) != methodFormatNumber(item.quantity)) ? 'text-warning' : ''"></i>
												<i class="fas fa-check text-success" v-if="ite.status_id == 56"
													:title="methodFormatNumber(ite.quantity) + ' ' + ite.product_id + ' generado (DS: ' + ite.order_sent_id + ')'"></i>
												<i class="fas fa-exclamation-circle text-warning"
													v-if="ite.status_id == 57"
													:title="ite.product_id + ' modificado (SUSC: ' + ite.order_sent_id + ')'"></i>
											</span>
										</td>
									</tr>
								</tbody>
							</table>
							<br>
							<div class="text-right">
								<button class="btn btn-sm btn-primary" data-toggle="modal"
									data-target="#changeSubscriptionModal"
									@click="clearChangeSubscriptionModal">Traslado o Cambio de Suscripcion</button>
							</div>
						</div>
					</div>
					<div class="card border-success mb-3">
						<div class="card-header">
							Pagos ({{ data.payments.length }})
							<span @click="openpayment = !openpayment" class="pointer float-right text-secondary">
								<i class="fas fa-plus" v-if="!openpayment"></i>
								<i class="fas fa-minus" v-else></i>
							</span>
						</div>
						<div class="card-body" v-show="openpayment">
							<table class="table table-sm table-12 table-bordered">
								<thead>
									<th class="text-center">#</th>
									<th class="text-center">Forma de Pago</th>
									<th class="text-center">Monto</th>
									<th class="text-center">Banco</th>
									<th class="text-center">Codigo</th>
									<th class="text-center">Descripción</th>
									<th class="text-center">Fecha</th>
								</thead>
								<tbody>
									<tr v-for="(item, index) in data.payments" :key="index">
										<td class="text-center">{{ item.id }}</td>
										<td>{{ item.typePayment }}</td>
										<td class="text-right">{{ methodFormatNumber(item.amount) }}</td>
										<td class="text-center">{{ item.bank }}</td>
										<td class="text-center">{{ item.code }}</td>
										<td>{{ item.description }}</td>
										<td class="text-center">{{ item.transaction_date }}</td>
										<td class="text-right">
											<i class="fas fa-check text-success" v-show="item.status_id == 39"
												title="Confirmado"></i>
											<i class="fas fa-exclamation-triangle text-warning"
												v-show="item.status_id == 40" title="Rechazado"></i>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="card border-info mb-3">
						<div class="card-header">
							Documentos Adjuntos ({{ data.upload_documents.length }})
							<span @click="openuploaddocument = !openuploaddocument"
								class="pointer float-right text-secondary">
								<i class="fas fa-plus" v-if="!openuploaddocument"></i>
								<i class="fas fa-minus" v-else></i>
							</span>
						</div>
						<div class="card-body row" v-show="openuploaddocument">
							<div class="col-4 text-center mb-3" v-for="(item, index) in data.upload_documents"
								:key="index">
								<div style="border:1px solid #ddd">
									<img :src="item.public_path + item.name_save" style="width:100%;" />
									<a :href="item.public_path + item.name_save" target="_blank">{{ item.name_original
										}}</a>
								</div>
							</div>
						</div>
					</div>
					<div class="card border-info mb-3" v-if="data.genesys != null">
						<div class="card-body row" v-show="openGenesys" @dblclick="infoConsole(data.genesys)">
							Migrado a Genesys el "<b> {{ data.genesys.fecmov }}</b>" con el Nº Comp "<b> {{
			data.genesys.nrocomp }}</b>"
						</div>
					</div>
					<a href="#legalDocument" ref="aLegalDocument"></a>
					<div class="card border-info mb-3" id="legalDocument">
						<div class="card-header">
							Documentos Legales ({{ data.legal_documents.length }})
							<span @click="openlegaldocuments = !openlegaldocuments"
								class="pointer float-right text-secondary">
								<i class="fas fa-plus" v-if="!openlegaldocuments"></i>
								<i class="fas fa-minus" v-else></i>
							</span>
						</div>
						<div class="card-body row" v-show="openlegaldocuments">
							<table class="table table-sm table-12 table-bordered">
								<thead>
									<th class="text-center">Tipo de documento</th>
									<th class="text-center">Folio</th>
									<th class="text-center">Fecha</th>
									<th class="text-center">RUT</th>
									<th class="text-center">Monto</th>
								</thead>
								<tbody>
									<tr v-for="(item, index) in data.legal_documents" :key="index">
										<td>{{ item.type_legal_document }}</td>
										<td class="text-center" :title="'ID ' + item.id">{{ item.legal_document_number
											}}
										</td>
										<td class="text-center">{{ item.date_legal_document | formatDate }}</td>
										<td class="text-center" :title="item.receiving_entity_name">
											{{ item.receiving_entity_document_number }}</td>
										<td class="text-right">{{ methodFormatNumber(item.total) }}</td>
										<td class="text-right">
											<i class="fas fa-file-download pointer margin-left5 text-info"
												v-if="item.url != ''" title="Descargar PDF"
												@click="downloadPDF(item.url)"></i>
											<i class="fas fa-file-download pointer margin-left5 text-warning"
												v-if="item.url_assignable != ''" title="Decargar PDF Cedible"
												@click="downloadPDF(item.url_assignable)"></i>
											<i class="far fa-paper-plane text-primary pointer"
												v-if="item.legal_document_number == 0"
												:title="'Generar ' + item.type_legal_document"
												@click="sendToRegulatoryEntityLocal(item)"></i>
											<i class="fas fa-print pointer margin-left5" v-else
												@click="toPrintFacturacionCL(item.type_legal_document_id, item.legal_document_number)"></i>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="card-footer text-right" v-if="data.legal_documents.length > 0">
							<button class="btn btn-link btn-sm" @click="showSendMailLegalDocumentModal">Enviar por
								correo</button>
						</div>
					</div>
				</div>
				<div class="col-lg-4">
					<div class="card" :class="'bg-' + data.color">
						<div class="card-body text-center">
							<h3>
								{{ data.status }}
								<i class="fas fa-dollar-sign text-success" title="PAGADO COMPLETO"
									v-if="data.paid == 1"></i>
							</h3>
						</div>
					</div>
					<div class="card">
						<div class="card-body">
							<h4 class="card-title text-center" style="width:100%">Datos Personales</h4>
							<p class="card-text">
								<span>Nombre: </span><label :title="'Código Cliente ' + data.client_id">{{
			data.client.name }}
									{{ data.client.surname }}</label>
							</p>
							<p class="card-text">
								<span>Telefono: </span><label>{{ data.phone }}</label>
							</p>
							<p class="card-text">
							<div>
								<span>{{ data.type_church }} </span><label
									:title="'Código Iglesia ' + data.church_id">{{ data.church.name }}</label>
								<i class="fas fa-link float-right pointer" title="Vincular iglesia con genesys"
									@click="showLinkChurchWithGenesysModalComponentLocal()"></i>
							</div>
							<div>
								Distrito {{ data.district }}
							</div>
							<div>
								{{ data.entity }}
							</div>
							</p>
							<hr>
							<h4 class="card-title text-center" style="width:100%">
								Total Suscripcion
							</h4>
							<h3 class="text-center" style="width:100%">$ {{ methodFormatNumber(data.total) }}</h3>
						</div>
					</div>
					<div class="text-right">
						<div class="form-check form-check-inline" v-if="visibleCheckMigrateGenesys">
							<input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"
								v-model="migrateGenesys">
							<span class="" for="inlineCheckbox1">Migrar a Genesys</span>
						</div>
						<button class="btn btn-sm btn-primary" v-if="data.status_id == 30"
							@click="confirmOrderLocal()">Confirmar</button>
						<button class="btn btn-sm btn-secondary"
							v-if="data.status_id == 31 && !visibleButtonMigrateGenesys && data.legal_documents.length == 0"
							@click="generateLegalDocumentDefaultLocal" :disabled="generatingLegalDocument">Boleta
							Rapida</button>
						<button class="btn btn-sm btn-secondary ml-1"
							v-if="data.status_id == 31 && !visibleButtonMigrateGenesys"
							@click="showLegalDocumentModalComponentLocal">Facturar</button>
						<button class="btn btn-sm btn-info" v-show="visibleButtonMigrateGenesys"
							@click="verifyChurchGenesysLocal(data.church_id)" :disabled="migratingOrderToGenesys">
							{{ (!migratingOrderToGenesys) ? 'Migrar a Genesys' : 'Migrando a Genesys...' }}
						</button>
					</div>
				</div>
			</div>
			<div>
				<div class="text-right">
					<button class="btn btn-sm btn-danger" v-if="data.paid == 0 && data.status_id == 30"
						@click="deleteOrderLocal()">Eliminar</button>
				</div>
				<hr>
				<div>
					<h6>Otras Suscripciones de {{ church }}</h6>
					<table class="table table-sm table-hover" v-if="!searchingOrders">
						<thead>
							<tr>
								<th class="text-center"><span class="pointer" @click="setOrderBy('orders.id')">ID</span>
								</th>
								<th class="text-center"><span class="pointer"
										@click="setOrderBy('orders.subscription_id')">Año</span></th>
								<th class="text-center"><span class="pointer"
										@click="setOrderBy('entities.synthetic')">Campo</span></th>
								<th class="text-center"><span class="pointer"
										@click="setOrderBy('orders.type_order_id')">Tipo Comprobante</span></th>
								<th class="text-center"><span class="pointer"
										@click="setOrderBy('clients.name')">Cliente</span></th>
								<th class="text-center"><span class="pointer"
										@click="setOrderBy('orders.created_at')">Fecha</span></th>
								<th class="text-center"><span class="pointer"
										@click="setOrderBy('orders.status_id')">Estado</span></th>
								<th class="text-center"><span class="pointer"
										@click="setOrderBy('orders.total')">Total</span></th>
								<th class="text-center">
									<span @click="setOrderBy('orders.paid')">Pagado</span>
								</th>
								<th class="text-center">Facturado</th>
								<th class="text-center">Migrado</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in listOrders" :key="index">
								<td class="text-center" @click="showConsole(item)">{{ item.id }}</td>
								<td class="text-center">{{ item.subscription_id }}</td>
								<td class="text-center">{{ item.synthetic }}</td>
								<td class="text-center">{{ item.type_order.name }}</td>
								<td class="text-center">{{ item.client.name }} {{ item.client.surname }}</td>
								<td class="text-center">{{ item.created_at }}</td>
								<td class="text-center" :title="item.status_id">{{ item.status }}</td>
								<td class="text-right">{{ methodFormatNumber(item.total) }}</td>
								<td class="text-center">
									<i class="fas fa-check text-success" v-if="item.paid == 1"></i>
									<i class="fas fa-minus text-black-50" v-else></i>
								</td>
								<td class="text-center">
									<i class="fas fa-check text-success" v-if="item.legal_documents.length > 0"></i>
									<i class="fas fa-minus text-black-50" v-else></i>
								</td>
								<td class="text-center">
									<i class="fas fa-check text-success" v-if="item.genesys != null"
										:title="'Comprobante de genesys ' + item.genesys.nrocomp"></i>
									<i class="fas fa-minus text-black-50" v-else></i>
								</td>
								<td class="text-right">
									<router-link :to="'/subscription/' + item.id" :target="'_blank ' + item.id"
										class="pointer far fa-eye text-info" title="Ver detalle"></router-link>
								</td>
							</tr>
						</tbody>
					</table>
					<div class="alert alert-secondary text-center" role="alert" v-else>
						Ahora estamos buscando otros comprobantes relacionados a {{ data.type_church }} {{
			data.church.name }}
						<img src="@/assets/search-color.gif" width="50px" />
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="jumbotron text-center" v-if="loadingSubscription">
				<h1 class="display-5">
					Buscando Comprobante
					<img src="@/assets/search-color.gif" width="100px" />
				</h1>
				<p class="lead">
					Estamos Buscando el comprobante Nº {{ id }} ...
				</p>
			</div>
			<div class="alert alert-warning " role="alert" v-else>
				Sin datos
			</div>
		</div>

		<link-church-with-genesys-modal-component ref="linkChurchWithGenesysModalComponent" v-if="data != null"
			:churchId="data.church_id">
		</link-church-with-genesys-modal-component>

		<legal-document-modal-component ref="legalDocumentModalComponent" :urlSearch="urlSearch"
			typeLegalDocumentsId="39" @postSaveLegalDocumentAction="postSaveLegalDocumentAction"
			@errorShowLocalDocument="errorShowLocalDocument">
		</legal-document-modal-component>

		<div class="modal fade" id="changeSubscriptionModal" tabindex="-1"
			aria-labelledby="changeSubscriptionModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="changeSubscriptionModalLabel">Traslados o cambios de suscripcion
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-md-6">
								<table class="table table-sm table-12">
									<thead>
										<tr>
											<th class="text-center">Codigo</th>
											<th class="text-center">Producto</th>
											<th class="text-center">Cantidad</th>
										</tr>
									</thead>
									<tbody>
										<tr class="pointer" v-for="(item, index) in listOrderProductsLocal" :key="index"
											v-if="analizeQuantitySubscriptionProducts(item.order_product_subscription_products) > 0"
											@dblclick="addListOrderProductsChange(item)">
											<td class="text-center">{{ item.product_id }}</td>
											<td>{{ item.product }}</td>
											<td class="text-right">
												{{
			methodFormatNumber(analizeQuantitySubscriptionProducts(item.order_product_subscription_products))
		}}
											</td>
										</tr>
									</tbody>
								</table>
								<div class="text-right text-black-50">
									<small><i>Haga doble click en el item a trasladar o cambiar</i></small>
								</div>
							</div>
							<div class="col-md-6">
								<div class="card">
									<div class="card-body">
										<h6>Datos de Traslado o Cambio</h6>
										<select class="form-control form-control-sm" v-model="typeOrderId"
											@change="setObjectOrderLocal">
											<option value="10">Traslado de Suscripción</option>
											<option value="13">Cambio de Suscripción</option>
										</select>
										<br>
										<div v-show="typeOrderId == 10">
											<div>
												<div class="form-group">
													<label for="inputChurch">Iglesia</label>
													<churchs-input-component ref="churchsInputComponent"
														:url="getApiBackend"
														@actionSelectItem="setChurchLocal"></churchs-input-component>
												</div>
												<div class="form-group">
													<label for="inputClient">Cliente</label>
													<autocomplete-input-component _class="form-control form-control-sm"
														:_path="getApiBackend + 'clients'"
														@actionSelectItem="setClientLocal"></autocomplete-input-component>
												</div>
											</div>
										</div>
										<div class="alert alert-warning" role="alert"
											v-if="objectOrder.order_products.length == 0">
											<small>Seleccione algún producto</small>
										</div>
										<div v-else>
											<hr>
											<table class="table table-sm table-12"
												v-if="this.objectOrder.type_order_id == 10">
												<thead>
													<tr>
														<th class="text-center">Código</th>
														<th class="text-center">Producto</th>
														<th class="text-center">Cantidad</th>
													</tr>
												</thead>
												<tbody>
													<tr class="pointer"
														v-for="(item, index) in objectOrder.order_products" :key="index"
														@dblclick="deleteListOrderProductsChange(index)">
														<td class="text-center">{{ item.product_id }}</td>
														<td>{{ item.product }}</td>
														<td class="text-right">
															<input type="text" class="text-right"
																v-model="item.quantity"
																:class="(item.quantity > item.quantity_original) ? 'text-danger' : ''" />
														</td>
													</tr>
												</tbody>
											</table>
											<div v-if="this.objectOrder.type_order_id == 13">
												<ul class="list-group" style="font-size: 12px">
													<li class="list-group-item"
														v-for="(item, index) in objectOrder.order_products"
														:key="index">
														{{ item.product }}
														<span class="badge badge-primary badge-pill">{{
			item.quantity_original }}</span>
														<button
															class="fas fa-plus-circle float-right text-primary pointer"
															:disabled="listProductsSubscription.length == 0"
															@click="addListOrderProductsChangeProduct(item)"></button>
														<div>
															<table class="table table-sm table-12">
																<tbody>
																	<tr v-for="(ite, inde) in item.newOrderProducts"
																		:key="inde">
																		<td width="60px">{{ ite.product_id }}
																		<td>
																		<td>
																			<select
																				style="font-size: 12px; padding: 0px; width:100%;"
																				v-model="ite.product_id"
																				:disabled="listProductsSubscription.length == 0">
																				<option
																					v-if="listProductsSubscription.length == 0"
																					disabled selected>Buscando
																					Productos...</option>
																				<option
																					v-for="(it, ind) in listProductsSubscription"
																					:key="ind" :value="it.product_id"
																					style="margin: 0px"
																					v-if="it.product_id != item.product_id">
																					{{ it.product }} ({{ it.product_id
																					}})
																				</option>
																			</select>
																		</td>
																		<td>
																			<input type="text" class="text-right"
																				v-model="ite.quantity"
																				style="width: 50px">
																		</td>
																		<td class="text-right">
																			<button
																				class="fas fa-minus-circle pointer text-danger"
																				:disabled="listProductsSubscription.length == 0"
																				v-show="item.newOrderProducts.length > 1"
																				@click="deleteListOrderProductsChangeProduct(index, inde)"></button>
																		</td>
																	</tr>
																</tbody>
															</table>
														</div>
														<div class="text-right">
															<small class="pointer"
																@click="deleteListOrderProductsChange(index)">quitar</small>
														</div>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal"
							ref="btnCloseChangeSubscriptionModal">Cerrar</button>
						<button type="button" class="btn btn-sm btn-primary" @click="saveOrderLocal"
							:disabled="bntSavingOrder">
							<span v-if="!savingOrder">Guardar</span>
							<span v-else>Guardando...</span>
						</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Button trigger modal -->
		<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#sendMailLegalDocumentModal"
			ref="btnSendMailLegalDocumentModal" v-show="false">
			Abrir Enviar Correo
		</button>

		<!-- Modal -->
		<div class="modal fade" id="sendMailLegalDocumentModal" tabindex="-1"
			aria-labelledby="sendMailLegalDocumentModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-body">
						<div v-if="!sendingMailLegalDocument">
							<div class="form-group">
								<div>
									<label for="emailSendLegalDocument">Correo Electronico</label>
									<button class="close" data-dismiss="modal" aria-label="Close">
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
								<div class="input-group mb-3">
									<input type="email" class="form-control form-control-sm" id="emailSendLegalDocument"
										placeholder="Ingrese el correo electronico"
										aria-label="Ingrese el correo electronico"
										aria-describedby="btnSendEmailSendLegalDocument"
										v-model="emailSendLegalDocument">
									<div class="input-group-append">
										<button class="btn btn-info btn-sm" type="button"
											id="btnSendEmailSendLegalDocument"
											:disabled="!isMail(emailSendLegalDocument)"
											@click="sendMailLegalDocumentLocal">Enviar</button>
									</div>
								</div>
								<small id="emailHelp" class="form-text text-success"
									v-if="isMail(emailSendLegalDocument)">Formato correcto.</small>
								<small id="emailHelp" class="form-text text-danger" v-else>Formato incorrecto.</small>
							</div>
						</div>
						<div v-else class="text-center">
							Enviando Correo electronico a {{ emailSendLegalDocument }} . . .
						</div>
					</div>
					<div class="modal-footer" v-show="false">
						<button type="button" class="btn btn-secondary" data-dismiss="modal"
							ref="btnCloseSendMailLegalDocumentModal">Close</button>
					</div>
				</div>
			</div>
		</div>



	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import order from '@/mixins/orders'
import orderSubscription from '@/mixins/orders/subscription.js'
import legalDocument from '@/mixins/legalDocuments'
import church from '@/mixins/generals/church.js'
import facturacionCLPrint from '@/mixins/facturacionCLPrint.js'
import subscription from '@/mixins/subscription'

import LegalDocumentModalComponent from '@/components/LegalDocumentModalComponent.vue'
import LinkChurchWithGenesysModalComponent from '@/components/LinkChurchWithGenesysModalComponent.vue'
import ChurchsInputComponent from '@/components/ChurchsInputComponent.vue'
import AutoCompleteInputComponent from '@/components/AutoCompleteInputComponent.vue'

export default {
	name: 'Subscription',
	mixins: [axiosAction, errors, mixin, order, orderSubscription, legalDocument, church, facturacionCLPrint, subscription],
	props: ['orderId'],
	data() {
		return {
			id: this.orderId,
			urlSearch: '',
			church: '',
			data: null,
			loadingSubscription: false,
			opendetail: true,
			openGenesys: true,
			openpayment: true,
			openuploaddocument: true,
			openlegaldocuments: true,
			migrateGenesys: true,
			otherLegalDocument: false,
			migratingOrderToGenesys: false,
			listOrderProductsChange: [],
			listProductsSubscription: [],
			typeOrderId: 0,
			emailSendLegalDocument: ''
		}
	},
	computed: {
		listOrderProductsLocal() {
			let list = []
			if (this.data != null) {
				list = this.data.order_products.filter(item => {
					let index = this.objectOrder.order_products.map((el) => parseInt(el.product_id)).indexOf(parseInt(item.product_id))
					if (index > -1)
						return false
					index = item.order_product_subscription_products.map(el => el.status_id).indexOf(null)
					if (index > -1)
						return true
					return false
				})
			}
			return list
		},
		visibleButtonMigrateGenesys() {
			return (this.data.status_id == 31 && this.needGenesys && this.data.genesys == null)
		},
		visibleCheckMigrateGenesys() {
			return (this.data.status_id == 30 && this.needGenesys && this.data.genesys == null)
		},
		bntSavingOrder() {
			if (this.savingOrder)
				return this.savingOrder
			if (this.objectOrder.type_order_id == 0)
				return true
			if (this.objectOrder.order_products.length == 0)
				return true
			if (this.objectOrder.type_order_id == 13) {
				let result = false
				this.objectOrder.order_products.forEach(item => {
					let sum = 0
					item.newOrderProducts.forEach(ite => {
						sum += parseInt(ite.quantity)
						if (ite.product_id == 0) {
							sum = 0
							return
						}
						if (parseInt(ite.quantity) == 0) {
							sum = 0
							return
						}
					})
					if (sum == 0 || isNaN(sum)) {
						result = true
						return
					}
					if (sum > item.quantity_original) {
						result = true
						return
					}
				})
				if (result)
					return result
			}
			if (this.objectOrder.type_order_id == 10) {
				let result = false
				this.objectOrder.order_products.forEach(item => {

					if (parseInt(item.quantity) > parseInt(item.quantity_original))
						result = true
					if (isNaN(parseInt(item.quantity)))
						result = true
				})
				if (result)
					return result

				if (this.objectOrder.client_id == 0)
					return true
				if (this.objectOrder.church_id == 0)
					return true
			}
			return false
		},
	},
	methods: {
		addListOrderProductsChange(item) {
			if (this.objectOrder.type_order_id > 0) {
				let it = this.newItemOrderProduct(item)
				it.newOrderProducts = []
				this.addListOrderProductsChangeProduct(it)
				this.objectOrder.order_products.push(it)
			} else {
				alert('Primero debe seleccionar el tipo de movimiento')
			}
		},
		deleteListOrderProductsChangeProduct(index, inde) {
			this.objectOrder.order_products[index].newOrderProducts.splice(inde, 1)
		},
		addListOrderProductsChangeProduct(item) {
			item.newOrderProducts.push({ product_id: 0, quantity: 1 })
		},
		initModuleLocal() {
			let title = (this.id > 0) ? 'Comprobante Nº ' + this.id : 'Nueva Suscripción'
			this.setTitleModule(title)
			this.setSubTitleModule('')
			this.getSubscriptionLocal()
			this.$refs.churchsInputComponent.$refs.getChurchs.click()
		},
		clearChangeSubscriptionModal() {
			this.typeOrderId = 0
			this.setObjectOrderLocal()
		},
		confirmOrderLocal() {
			this.addOrderTrackingsOrder(this.id, 2, 'Boton Modulo Suscripcion')
		},
		addOrderTrackingsOrderResultLocal(response) {
			this.data.status_id = response.data.data.statu.id
			this.data.status = response.data.data.statu.name
			this.data.color = response.data.data.statu.color
			this.$snotify.success('La suscripción Nº ' + response.data.data.order_id + ' se ha confirmado con exito!!!', 'Confirmado')
			if (this.needGenesys && this.migrateGenesys) {
				this.verifyChurchGenesysLocal(this.data.church_id)
			}
			this.updateItemListOrders(this.data)
		},
		analizeSubscriptionProducts(item) {
			let list = []
			let index = -1
			item.forEach(element => {
				index = list.map((el) => parseInt(el.product_id)).indexOf(parseInt(element.product_id))
				if (index == -1) {
					let li = []
					for (let i = 0; i < item.length; i++) {
						if (item[i].product_id == element.product_id) {
							li.push(item[i])
						}
					}
					if (li.length > 0) {
						list.push(li[li.length - 1])
					}
					if (element.product_subscription_id == 56) {
					}

				}
			})
			return list
		},
		analizeQuantitySubscriptionProducts(item) {
			let q = 0
			item.forEach(element => {
				if (element.status_id == null) {
					q = element.quantity
					return
				}
			})
			if (q == 0) {
				if (item[item.length - 1].status_id == 57) {
					return 0
				}
				return item[item.length - 1].quantity
			}
			return q
		},
		deleteListOrderProductsChange(index) {
			let orderProductsChange = this.objectOrder.order_products.splice(index, 1)
		},
		deleteOrderLocal() {
			if (confirm('Esta a punto de borrar la suscripción Nº ' + this.id + '\n¿Quiere continuar?')) {
				this.deleteOrder(this.id)
			}
		},
		deleteOrderResultLocal(response) {
			this.$router.push('/subscriptions');
		},
		errorShowLocalDocument(response) {
			console.log(response.data.success, this.otherLegalDocument)
			if (response.data.success === false && !this.otherLegalDocument) {
				this.$snotify.warning(response.data.data, response.data.message)
				this.msgSearching = response.data.data
				setTimeout(() => { this.$refs.legalDocumentModalComponent.$refs.btnCloseLegalDocumentModalComponent.click() }, 1000)
			} else if (response.data.success === false && this.otherLegalDocument) {
				this.$snotify.success('Proceso de facturación terminada', 'Terminado')
				setTimeout(() => { this.$refs.legalDocumentModalComponent.$refs.btnCloseLegalDocumentModalComponent.click() }, 1000)
			}
			this.otherLegalDocument = false
		},
		generateLegalDocumentDefaultLocal() {
			let param = 'typeLegalDocumentsId=39&clientId=1&autoSave=1'
			this.generateLegalDocumentDefault(this.id, param)
		},
		generateLegalDocumentDefaultResultLocal(response) {
			if (response.data.success == true) {
				if (response.data.data.length > 0) {
					this.$snotify.success(response.data.message, 'Boleteado!!!')
					this.data.legal_documents = response.data.data
					this.$refs.aLegalDocument.click()
				} else {
					alert(response.data.message)
				}
			} else {
				alert(response.data.data)
			}
		},
		getSubscriptionLocal() {
			document.title = 'Buscando suscripción ' + this.id + ' . . .'
			this.loadingSubscription = true
			this.getSubscription(this.id)
		},
		getSubscriptionResultLocal(response) {
			if (response.data.success === true) {
				this.data = response.data.data
				document.title = 'Suscripción ' + response.data.data.id
				this.church = response.data.data.type_church + ' ' + response.data.data.church.name
				let title = response.data.data.type_order.name + ' Nº ' + this.id + ' - ' + this.church
				this.setTitleModule(title)
				this.getOthersSubscriptionsChurch(response.data.data.church_id, response.data.data.id)
				this.getProductSubscriptionByYear(this.data.subscription_id)
				if (response.data.data.type_order_id == 3) {
					this.reportGenesys('subscription')
				}
				//console.log(response.data.data.legal_documents[0].id)
				//this.migrateLegalDocumentToGenesys(response.data.data.legal_documents[0].id)
			}
		},
		getAllOrdersResultLocal(response) {
		},
		getProductSubscriptionByYearResultLocal(response) { },
		migrateLegalDocumentToGenesysResultLocal(response) { },
		migrateOrderToGenesysLocal(id) {
			this.migratingOrderToGenesys = true
			this.migrateOrderToGenesys(id, 'subscription')
		},
		migrateOrderToGenesysResultLocal(response) {
			if (response.data.success == true) {
				this.data.genesys = response.data.data
			} else {
				alert(response.data.message)
				console.log(response)
			}
			this.migratingOrderToGenesys = false
		},
		newItemOrderProduct(item) {
			let newItem = Object.create(item)
			let obj = {}
			for (const property in newItem) {
				obj[property] = newItem[property]
			}
			obj.quantity_original = this.methodFormatNumber(this.analizeQuantitySubscriptionProducts(obj.order_product_subscription_products))
			obj.quantity = 1
			return obj
		},
		postSaveLegalDocumentAction(data) {
			this.saveOrderLegalDocument(data.origenId, data.id)
			setTimeout(() => { this.$refs.legalDocumentModalComponent.$refs.btnCloseLegalDocumentModalComponent.click() }, 100)
		},
		reportGenesysResultLocal(response) {
			if (response.data.success == true) {
				this.needGenesys = response.data.data
				this.migratedOrderToGenesys = (this.data.genesys != null)
			}
		},
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch (responseLocal) {
				case 'addOrderTrackingsOrderResult': this.addOrderTrackingsOrderResult(response); break;
				case 'deleteOrderResult': this.deleteOrderResult(response); break;
				case 'generateLegalDocumentDefaultResult': this.generateLegalDocumentDefaultResult(response); break;
				case 'getAllOrdersResult': this.getAllOrdersResult(response); break;
				case 'getAllChurchsGenesysResult': this.getAllChurchsGenesysResult(response); break;
				case 'getSubscriptionResult': this.getSubscriptionResult(response); break;
				case 'getProductSubscriptionByYearResult': this.getProductSubscriptionByYearResult(response); break;
				case 'migrateLegalDocumentToGenesysResult': this.migrateLegalDocumentToGenesysResult(response); break;
				case 'migrateOrderToGenesysResult': this.migrateOrderToGenesysResult(response); break;
				case 'reportGenesysResult': this.reportGenesysResultLocal(response); break;
				case 'saveOrderLegalDocumentResult': this.saveOrderLegalDocumentResult(response); break;
				case 'saveOrderSubscriptionChangeResult': this.saveOrderSubscriptionChangeResult(response); break;
				case 'sendMailLegalDocumentResult': this.sendMailLegalDocumentResult(response); break;
				case 'sendToRegulatoryEntityResult': this.sendToRegulatoryEntityResult(response); break;
				case 'verifyChurchGenesysResult': this.verifyChurchGenesysResult(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		saveOrderLegalDocumentResultLocal(response) {
			this.$snotify.info('Se guardó el documento electronico con el ID ' + response.data.data.legal_document_id)
			this.sendToRegulatoryEntity(response.data.data.legal_document_id)
		},
		saveOrderLocal() {
			this.saveOrderSubscriptionChange(this.id, this.objectOrder)
		},
		saveOrderSubscriptionChangeResultLocal(response) {
			if (response.data.success == true) {
				let orderProducts = response.data.data.order_products
				orderProducts.forEach(op => {
					let index = this.objectOrder.order_products.map(el => parseInt(el.id)).indexOf(parseInt(op.id))
					if (index > -1) {
						this.objectOrder.order_products[index].order_product_subscription_products = null
						this.objectOrder.order_products[index].order_product_subscription_products = op.order_product_subscription_products
					}
				});
				this.$snotify.success('Se realizó con exito los cambios, Nº ' + response.data.data.orderNew.id, 'Realizado')
				this.$refs.btnCloseChangeSubscriptionModal.click()
			} else {
				alert('No se ha recibido lo que se esperaba, comuniquese con sistemas')
				console.log('Problemas', response.data)
			}
		},
		sendMailLegalDocumentLocal() {
			if (this.isMail(this.emailSendLegalDocument)) {
				this.sendMailLegalDocument(this.data.id, this.emailSendLegalDocument)
			} else {
				alert('Formato incorrecto del correo')
			}
		},
		sendMailLegalDocumentResultLocal(response) {
			if (response.data.success == true) {
				this.$snotify.success('Correo enviado', 'Realizado')
				this.$refs.btnCloseSendMailLegalDocumentModal.click()
			} else {
				this.$snotify.error(response.data.message, 'ERROR!!')
			}
		},
		sendToRegulatoryEntityResultLocal(response) {
			this.otherLegalDocument = true
			this.showLegalDocumentModalComponentLocal()
			this.data.legal_documents.push(response.data.data)
			this.migrateLegalDocumentToGenesys(response.data.data.id)
		},
		setChurchLocal(item) {
			this.objectOrder.church_id = item.id
		},
		setClientLocal(item) {
			this.objectOrder.client_id = item.id
		},
		setObjectOrderLocal() {
			this.clearObjectOrder()
			this.$refs.churchsInputComponent.$refs.clear.click()
			this.objectOrder.type_order_id = this.typeOrderId
			if (this.objectOrder.type_order_id == 13) {
				this.objectOrder.church_id = this.data.church_id
				this.objectOrder.church = this.data.church
				this.objectOrder.client_id = this.data.client_id
				this.objectOrder.paid = this.data.paid
				this.objectOrder.subscription_id = this.data.subscription_id
			}
			this.listOrderProductsChange = []
		},
		showLegalDocumentModalComponentLocal() {
			this.urlSearch = this.getApiBackend + 'order/' + this.id + '/legalDocumentForSubscription'
			setTimeout(() => { this.$refs.legalDocumentModalComponent.$refs.btnShowLegalDocumentModalComponent.click() }, 100)
		},
		showLinkChurchWithGenesysModalComponentLocal() {
			this.$refs.linkChurchWithGenesysModalComponent.$refs.btnShowLinkChurchWithGenesysModalComponent.click()
		},
		showSendMailLegalDocumentModal() {
			this.emailSendLegalDocument = this.data.client.email
			this.$refs.btnSendMailLegalDocumentModal.click()
		},
		updateData(item) {
			if (item.id == this.id) {
				for (const property in item) {
					this.data[property] = item[property]
				}
			}
		},
		verifyChurchGenesysLocal(id) {
			this.verifyChurchGenesys(id)
		},
		verifyChurchGenesysResultLocal(response) {
			if (response.data.success == true) {
				let data = response.data.data.data[0]
				if (confirm('Se migrará al cliente de genesys:\n\n' + data.cliape.toUpperCase() + ' ' + data.clinom.toUpperCase() + ' (' + data.clicod + ')\n\n¿Quiere continuar?')) {
					this.migrateOrderToGenesysLocal(this.data.id)
				}
			} else {
				alert(response.data.message)
			}
		},
	},
	components: {
		'legal-document-modal-component': LegalDocumentModalComponent,
		'link-church-with-genesys-modal-component': LinkChurchWithGenesysModalComponent,
		'churchs-input-component': ChurchsInputComponent,
		'autocomplete-input-component': AutoCompleteInputComponent,
	},
	mounted() {
		this.initModule()
	}
}

</script>

<style scoped lang="scss"></style>